export default __webpack_public_path__ + "static/media/4.6a7d828c.jpg";